class Tabs extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const $element = this;
    const $tabsBtn = this.querySelectorAll("[tab-item]");

    if (!$tabsBtn) throw new Error("Tabs btn not found");

    $tabsBtn.forEach(($tabBtn) => {
      $tabBtn.addEventListener("click", (e) => {
        e.preventDefault();
        // tabs buttons
        const $activeTabBtn = $element.querySelector("[tab-item].tab-active");
        if ($activeTabBtn) $activeTabBtn.classList.remove("tab-active");
        $tabBtn.classList.add("tab-active");

        // tabs content
        const tabId = $tabBtn.dataset.id;
        const $targetTab = $element.querySelector(
          `[tab-content][data-id="${tabId}"]`
        );
        const $activeContentTab = $element.querySelector(
          "[tab-content].is-active"
        );
        if ($activeContentTab) $activeContentTab.classList.remove("is-active");
        if ($targetTab) $targetTab.classList.add("is-active");
      });
    });
  }
}

customElements.define("vite-tabs", Tabs);

class TabsOptimize extends Tabs {
  constructor() {
    super();
    this.$tabsBtn = this.querySelectorAll("[tab-item]");
    this.loadedCollections = new Set();
  }

  connectedCallback() {
    window.addEventListener("DOMContentLoaded", () => {
      this.fetchAllTabContents();
    });
  }

  async fetchAllTabContents() {
    if (this.isLoading) return;
    this.isLoading = true;

    const promises = Array.from(this.$tabsBtn).map(async ($tabBtn, index) => {
      // Vérifier d'abord si c'est la première tab
      if (index === 0) {
        const $tabContentItems = this.querySelector(
          `[tab-content][data-handle-url='${$tabBtn.getAttribute(
            "data-handle-url"
          )}'] [tab-content-items]`
        );
        if ($tabContentItems) {
          this.loadedCollections.add($tabBtn.getAttribute("data-handle-url"));
        }
        return;
      }

      const handleCollection = $tabBtn.getAttribute("data-handle-url");
      if (!handleCollection || this.loadedCollections.has(handleCollection))
        return;

      const $tabContentItems = this.querySelector(
        `[tab-content][data-handle-url='${handleCollection}'] [tab-content-items]`
      );

      if (!$tabContentItems) {
        console.error(
          `Tabs content container not found for ${handleCollection}`
        );
        return;
      }

      // Vérifier si le contenu est déjà présent
      if ($tabContentItems.children.length > 0) {
        this.loadedCollections.add(handleCollection);
        return;
      }

      try {
        const newHTMLContent = await this.fetchCollectionTabsHTML(
          handleCollection
        );
        $tabContentItems.innerHTML = newHTMLContent;
        this.loadedCollections.add(handleCollection);
      } catch (error) {
        console.error(
          `Error loading content for collection ${handleCollection}:`,
          error
        );
      }
    });

    await Promise.all(promises);
    this.isLoading = false;
  }

  async fetchCollectionTabsHTML(handleCollection) {
    const url = `${Shopify.routes.root}collections/${handleCollection}?view=tabs`;
    try {
      const response = await fetch(url);
      if (response.status !== 200) {
        console.error(
          `Error: Fetch request failed with status ${response.status}`
        );
        return "";
      }

      return response.text();
    } catch (error) {
      console.error("Error fetching collection tabs:", error);
      return "";
    }
  }
}

customElements.define("vite-tabs-optimize", TabsOptimize);
